import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GpsNotFixedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gps_not_fixed"}/>
}
